// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"839c8273","644":"d8ecc902","758":"2bd04452","980":"e51c063a"}[chunkId] + ".chunk.css";
};